import { useMutation } from '@tanstack/react-query';
import { ApiEndpoints } from 'types/api';

export interface Response {
  img: string;
}

export async function uploadFile(file: File): Promise<Response | Error> {
  const formData = new FormData();

  formData.append('file', file);

  const response = await fetch(ApiEndpoints.IMAGE_UPLOAD, {
    method: 'POST',
    body: formData,
  });

  if (response.status === 200) {
    return await response.json();
  }

  if (response.status === 413) {
    return new Error(`File ${file.name} is too large`);
  }

  if (response.status === 422) {
    return new Error(
      `File ${file.name} has incorrect format. Allowed file types: .png, .jpg, .webp`,
    );
  }

  return new Error('Uploading error');
}

export function useImageUpload() {
  const {
    mutateAsync: upload,
    isLoading: isUploading,
    error,
  } = useMutation<Response | Error, Error, File>(uploadFile);

  return {
    error,
    upload,
    isUploading,
  };
}
